import { OrderCategory } from './model/ordercategory';

export class OrderInfo {
  public model: any;
  public category: OrderCategory;
}
